import { body, theme } from "../../../utils/theme";

export const styles = {
  dialog: {
    backgroundColor: theme.palette.background.default,
    overflow: "hidden",
  },
  dialogBackground: {
    filter: "brightness(0.9) blur(2px)",
    height: "100vh",
    right: 0,
    top: 0,
    overflow: "hidden",
    position: "absolute",
    width: "100vw",
    zIndex: 0,
  },
  dialogHeader: {
    alignItems: "center",
    color: theme.palette.grays[900],
    display: "flex",
    paddingBottom: 4,
    // paddingLeft: "7.5px",
    pr: -3,
    pt: 3,
    width: body.width,
  },
  dialogHeaderContainer: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    zIndex: 1,
  },
  dialogListContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "flex-start",
    ml: 9,
    mt: 8,
    pb: 4,
    pt: 0,
    width: "100%",
  },
  dialogVideo: {
    height: "100%",
    left: 0,
    position: "absolute",
    width: { xs: "inherit", md: "100%" },
  },
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  headerIcon: {
    alignItems: "center",
    display: "flex",
    color: theme.palette.grays[700],
    justifyContent: "center",
  },
  icon: {
    alignItems: "center",
    color: theme.palette.primary.main,
    display: "flex",
    justifyContent: "center",
    ml: 3,
  },
  margin: {
    display: "flex",
    margin: theme.spacing(1),
  },
  navMenuContainer: {
    alignItems: "center",
    color: theme.palette.secondary.main,
    display: { md: "none", xs: "flex" },
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  navSubtext: {
    alignItems: "center",
    display: "flex",
    color: theme.palette.grays[800],
    fontSize: theme.typography.h5,
    fontWeight: 500,
    letterSpacing: 1.2,
    lineHeight: 1,
    marginLeft: 12,
    textTransform: "inherit",
  },
  navText: {
    alignItems: "center",
    display: "flex",
    color: theme.palette.secondary.main,
    fontSize: theme.typography.h3,
    fontWeight: 500,
    letterSpacing: 1.2,
    textDecoration: "none",
    textTransform: "capitalize",
  },
};
